import { render, staticRenderFns } from "./timeAndAreaTj.vue?vue&type=template&id=01afa4f8&scoped=true&"
import script from "./timeAndAreaTj.vue?vue&type=script&lang=js&"
export * from "./timeAndAreaTj.vue?vue&type=script&lang=js&"
import style0 from "./timeAndAreaTj.vue?vue&type=style&index=0&id=01afa4f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01afa4f8",
  null
  
)

export default component.exports